// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contract-settings-container {
  /* padding: 30px; */
  max-width: 800px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 0 !important;
  padding: 0 !important;
}

.contract-settings-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
}

.contract-title {
  font-size: 24px;
  font-weight: bold;
  margin: 0;
}

.edit-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px 15px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
  width: 170px !important;
  height: 50px;
}

.edit-button.save-mode {
  background-color: #ff6b00;
  color: white;
  border: none;
}

.edit-icon, .ok-icon {
  margin-right: 8px;
}

.ok-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  color: #ff6b00;
  width: 20px;
  height: 20px;
  border-radius: 2px;
  font-size: 12px;
  font-weight: bold;
}

.contract-section {
  /* margin-top: 10px; */
  margin-bottom: 30px !important;
  max-width: 600px;
}

.section-title {
  font-size: 18px !important;
  font-weight: 400 !important;
  margin-bottom: 10px !important;
  display: flex;
  align-items: space-evenly;
}

.help-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #ddd;
  color: #666;
  font-size: 14px;
  margin-left: 8px;
  cursor: pointer;
  position: relative; /* 이 부분이 중요: 박스 위치 기준점 */
}

/* 각 설정 항목 행 스타일 수정 */
.setting-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 15px;
  width: 100%;
}

/* 컨테이너 스타일 */
.setting-container {
  flex: 1 1;
  margin-right: 15px;
}

/* 모든 컨테이너 크기 통일 */
.time-input-container,
.wage-input-container,
.advanced-time-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff8f2;
  border-radius: 5px;
  padding: 15px 20px;
  width: 100%; /* 너비를 100%로 설정 */
  max-width: 480px; /* 최대 너비 고정 */
  height: 50px; /* 높이 고정 */
  box-sizing: border-box; /* 패딩을 포함한 크기 계산 */
  margin-right: 20px; /* 토글과의 간격 */
  text-align: center;
}

.time-input, .wage-input {
  background: white;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 8px 12px;
  font-size: 16px;
  width: calc(100% - 24px);
  text-align: center;
}

.wage-input {
  text-align: right;
  margin-right: 10px;
}

.time-input {
  width: 80px;
}

/* 정규 출퇴근 시간 컨테이너 - 그래도 회색 배경 유지 */
.regular-work-time {
  background-color: #e0e0e0;
}

/* 텍스트가 길어도 잘리지 않도록 조정 */
.wage-display {
  font-size: 16px;
  margin-right: 5px;
  white-space: nowrap; /* 텍스트 줄바꿈 방지 */
  overflow: hidden; /* 넘치는 내용 숨김 */
  text-overflow: ellipsis; /* 넘치는 텍스트에 ... 표시 */
  text-align: right;
}

.wage-unit {
  font-size: 16px;
  color: #888;
  white-space: nowrap; /* 텍스트 줄바꿈 방지 */
}

/* 시간 텍스트도 동일하게 조정 */
.time-display {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  white-space: nowrap; /* 텍스트 줄바꿈 방지 */
}

/* 토글 스위치 여백 조정 */
.toggle-switch {
  position: relative;
  width: 50px;
  height: 24px;
  border-radius: 15px;
  background-color: #ccc;
  cursor: pointer;
  transition: background-color 0.3s;
  flex-shrink: 0;
  margin-left: 20px; /* 여백 더 키움 */
}

/* 페이지 구조 조정 */
.contract-section, 
.advanced-option {
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
}

/* 기본 임금과 시간 설정 행 동일한 구조 */
.setting-row {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
}

.advanced-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: 1px solid #ff6b00;
  border-radius: 5px;
  padding: 0;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.3s;
  width: 170px;
  height: 50px;
  box-shadow: 0 2px 6px rgba(255, 107, 0, 0.2);
}

.advanced-button:hover {
  background-color: rgba(255, 107, 0, 0.05);
  box-shadow: 0 4px 8px rgba(255, 107, 0, 0.3);
}

.arrow-icon {
  display: flex;
  align-items: center;
  margin-right: 8px;
  color: #ff6b00 !important;
}

.arrow-icon svg {
  width: 24px;
  height: 24px;
}

.arrow-icon.open {
  /* transform: rotate(90deg); */
}

.advanced-settings-section {
  display: flex;
  flex-direction: column;
}

.advanced-options {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: visible;
}

.advanced-option {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.time-input-container.single-time {
  justify-content: center;
}

.advanced-option .time-input-container {
  background-color: #fff8f2;
}

/* 토글 스위치 스타일 */
.toggle-switch.enabled {
  background-color: #000;
}

.toggle-button {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: white;
  transition: transform 0.3s;
}

.toggle-switch.enabled .toggle-button {
  transform: translateX(26px);
}

/* 휴게 시간 행 스타일 - 버튼이 보이도록 수정 */
.break-time-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  width: 100%;
}

/* 휴게 시간 컨테이너 스타일 */
.break-time-container {
  flex: 1 1;
  margin-right: 10px;
}

/* 삭제 버튼 스타일 - 확실히 보이도록 수정 */
.remove-break-time-btn {
  width: 36px;
  height: 36px;
  display: flex !important; /* 강제 표시 */
  align-items: center;
  justify-content: center;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: white;
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
  margin-left: 15px;
  margin-right: 15px;
  z-index: 10; /* 다른 요소보다 위에 표시 */
}

/* 추가 버튼 스타일 - 확실히 보이도록 수정 */
.add-break-time-btn {
  width: 36px;
  height: 36px;
  display: flex !important; /* 강제 표시 */
  align-items: center;
  justify-content: center;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: white;
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 30px;
  z-index: 10; /* 다른 요소보다 위에 표시 */
}

/* 시간 구분자 스타일 */
.time-separator {
  margin: 0 15px;
}

/* 스크롤 스타일 커스터마이징 - 메인 컨테이너에만 적용 */
.contract-settings-container::-webkit-scrollbar {
  width: 6px;
}

.contract-settings-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.contract-settings-container::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}

.contract-settings-container::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}

/* 활성화/비활성화 상태에 따른 컨테이너 배경색 */
.time-input-container.active {
  background-color: #fff8f2; /* 활성화 상태: 메인 컬러(베이지) */
}

.time-input-container.inactive {
  background-color: #e0e0e0; /* 비활성화 상태: 회색 */
}

/* 정규 출퇴근 시간 컨테이너 - 활성화 상태일 때만 회색 유지 */
.regular-work-time.active {
  background-color: #fff8f2; /* 정규 출퇴근 시간은 항상 회색 배경 */
}

/* 기본 임금 컨테이너 - 활성화/비활성화 상태 구분 */
.wage-input-container.active {
  background-color: #fff8f2; /* 활성화 상태: 메인 컬러(베이지) */
}

.wage-input-container.inactive {
  background-color: #e0e0e0; /* 비활성화 상태: 회색 */
}

/* 도움말 박스 위치 수정 */
.help-tip-box {
  position: absolute;
  bottom: 30px; /* 아래에서부터의 거리 */
  left: 50%;    /* 가운데 정렬을 위해 */
  transform: translateX(-50%); /* 가운데 정렬 완료 */
  width: 300px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  padding: 15px;
  z-index: 100;
}

/* 도움말 박스 제목 */
.help-tip-box h3 {
  margin: 0 0 10px 0;
  font-size: 16px;
  font-weight: bold;
}

/* 도움말 박스 내용 */
.help-tip-box p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
}

/* 화살표 위치 수정 */
.help-tip-arrow {
  position: absolute;
  width: 15px;
  height: 15px;
  background: white;
  transform: rotate(45deg);
  bottom: -8px;
  left: 50%;    /* 가운데 정렬 */
  margin-left: -7px; /* 화살표 크기의 절반만큼 다시 왼쪽으로 이동 */
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
} `, "",{"version":3,"sources":["webpack://./src/styles/ContractSettings.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB,EAAE,wBAAwB;AAC9C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA,aAAa;AACb;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;;;EAGE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW,EAAE,iBAAiB;EAC9B,gBAAgB,EAAE,aAAa;EAC/B,YAAY,EAAE,UAAU;EACxB,sBAAsB,EAAE,kBAAkB;EAC1C,kBAAkB,EAAE,YAAY;EAChC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB,EAAE,eAAe;EACpC,gBAAgB,EAAE,cAAc;EAChC,uBAAuB,EAAE,oBAAoB;EAC7C,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB,EAAE,eAAe;AACtC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,mBAAmB,EAAE,eAAe;AACtC;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,iCAAiC;EACjC,cAAc;EACd,iBAAiB,EAAE,YAAY;AACjC;;AAEA,cAAc;AACd;;EAEE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB,EAAE,UAAU;EACpC,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW,EAAE,kBAAkB;AACjC;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB,EAAE,UAAU;EACpC,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW,EAAE,kBAAkB;AACjC;;AAEA,eAAe;AACf;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB,EAAE,uBAAuB;AACpD;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;AAC7C;;AAEA,sCAAsC;AACtC;EACE,yBAAyB,EAAE,wBAAwB;AACrD;;AAEA,gCAAgC;AAChC;EACE,yBAAyB,EAAE,uBAAuB;AACpD;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;AAC7C;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,YAAY,EAAE,eAAe;EAC7B,SAAS,KAAK,eAAe;EAC7B,2BAA2B,EAAE,cAAc;EAC3C,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,YAAY;AACd;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;EACZ,SAAS,KAAK,WAAW;EACzB,iBAAiB,EAAE,4BAA4B;EAC/C,4BAA4B;EAC5B,6BAA6B;AAC/B","sourcesContent":[".contract-settings-container {\n  /* padding: 30px; */\n  max-width: 800px;\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n.contract-settings-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 40px;\n}\n\n.contract-title {\n  font-size: 24px;\n  font-weight: bold;\n  margin: 0;\n}\n\n.edit-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: white;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  padding: 10px 15px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.3s;\n  width: 170px !important;\n  height: 50px;\n}\n\n.edit-button.save-mode {\n  background-color: #ff6b00;\n  color: white;\n  border: none;\n}\n\n.edit-icon, .ok-icon {\n  margin-right: 8px;\n}\n\n.ok-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-color: white;\n  color: #ff6b00;\n  width: 20px;\n  height: 20px;\n  border-radius: 2px;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.contract-section {\n  /* margin-top: 10px; */\n  margin-bottom: 30px !important;\n  max-width: 600px;\n}\n\n.section-title {\n  font-size: 18px !important;\n  font-weight: 400 !important;\n  margin-bottom: 10px !important;\n  display: flex;\n  align-items: space-evenly;\n}\n\n.help-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background-color: #ddd;\n  color: #666;\n  font-size: 14px;\n  margin-left: 8px;\n  cursor: pointer;\n  position: relative; /* 이 부분이 중요: 박스 위치 기준점 */\n}\n\n/* 각 설정 항목 행 스타일 수정 */\n.setting-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: 15px;\n  width: 100%;\n}\n\n/* 컨테이너 스타일 */\n.setting-container {\n  flex: 1;\n  margin-right: 15px;\n}\n\n/* 모든 컨테이너 크기 통일 */\n.time-input-container,\n.wage-input-container,\n.advanced-time-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #fff8f2;\n  border-radius: 5px;\n  padding: 15px 20px;\n  width: 100%; /* 너비를 100%로 설정 */\n  max-width: 480px; /* 최대 너비 고정 */\n  height: 50px; /* 높이 고정 */\n  box-sizing: border-box; /* 패딩을 포함한 크기 계산 */\n  margin-right: 20px; /* 토글과의 간격 */\n  text-align: center;\n}\n\n.time-input, .wage-input {\n  background: white;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 8px 12px;\n  font-size: 16px;\n  width: calc(100% - 24px);\n  text-align: center;\n}\n\n.wage-input {\n  text-align: right;\n  margin-right: 10px;\n}\n\n.time-input {\n  width: 80px;\n}\n\n/* 정규 출퇴근 시간 컨테이너 - 그래도 회색 배경 유지 */\n.regular-work-time {\n  background-color: #e0e0e0;\n}\n\n/* 텍스트가 길어도 잘리지 않도록 조정 */\n.wage-display {\n  font-size: 16px;\n  margin-right: 5px;\n  white-space: nowrap; /* 텍스트 줄바꿈 방지 */\n  overflow: hidden; /* 넘치는 내용 숨김 */\n  text-overflow: ellipsis; /* 넘치는 텍스트에 ... 표시 */\n  text-align: right;\n}\n\n.wage-unit {\n  font-size: 16px;\n  color: #888;\n  white-space: nowrap; /* 텍스트 줄바꿈 방지 */\n}\n\n/* 시간 텍스트도 동일하게 조정 */\n.time-display {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  white-space: nowrap; /* 텍스트 줄바꿈 방지 */\n}\n\n/* 토글 스위치 여백 조정 */\n.toggle-switch {\n  position: relative;\n  width: 50px;\n  height: 24px;\n  border-radius: 15px;\n  background-color: #ccc;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  flex-shrink: 0;\n  margin-left: 20px; /* 여백 더 키움 */\n}\n\n/* 페이지 구조 조정 */\n.contract-section, \n.advanced-option {\n  margin-bottom: 20px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n/* 기본 임금과 시간 설정 행 동일한 구조 */\n.setting-row {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.advanced-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: 1px solid #ff6b00;\n  border-radius: 5px;\n  padding: 0;\n  cursor: pointer;\n  font-size: 16px;\n  transition: all 0.3s;\n  width: 170px;\n  height: 50px;\n  box-shadow: 0 2px 6px rgba(255, 107, 0, 0.2);\n}\n\n.advanced-button:hover {\n  background-color: rgba(255, 107, 0, 0.05);\n  box-shadow: 0 4px 8px rgba(255, 107, 0, 0.3);\n}\n\n.arrow-icon {\n  display: flex;\n  align-items: center;\n  margin-right: 8px;\n  color: #ff6b00 !important;\n}\n\n.arrow-icon svg {\n  width: 24px;\n  height: 24px;\n}\n\n.arrow-icon.open {\n  /* transform: rotate(90deg); */\n}\n\n.advanced-settings-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.advanced-options {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  overflow: visible;\n}\n\n.advanced-option {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.time-input-container.single-time {\n  justify-content: center;\n}\n\n.advanced-option .time-input-container {\n  background-color: #fff8f2;\n}\n\n/* 토글 스위치 스타일 */\n.toggle-switch.enabled {\n  background-color: #000;\n}\n\n.toggle-button {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background-color: white;\n  transition: transform 0.3s;\n}\n\n.toggle-switch.enabled .toggle-button {\n  transform: translateX(26px);\n}\n\n/* 휴게 시간 행 스타일 - 버튼이 보이도록 수정 */\n.break-time-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  width: 100%;\n}\n\n/* 휴게 시간 컨테이너 스타일 */\n.break-time-container {\n  flex: 1;\n  margin-right: 10px;\n}\n\n/* 삭제 버튼 스타일 - 확실히 보이도록 수정 */\n.remove-break-time-btn {\n  width: 36px;\n  height: 36px;\n  display: flex !important; /* 강제 표시 */\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  background-color: white;\n  cursor: pointer;\n  font-size: 18px;\n  font-weight: bold;\n  margin-left: 15px;\n  margin-right: 15px;\n  z-index: 10; /* 다른 요소보다 위에 표시 */\n}\n\n/* 추가 버튼 스타일 - 확실히 보이도록 수정 */\n.add-break-time-btn {\n  width: 36px;\n  height: 36px;\n  display: flex !important; /* 강제 표시 */\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  background-color: white;\n  cursor: pointer;\n  font-size: 18px;\n  font-weight: bold;\n  margin-top: 10px;\n  margin-bottom: 30px;\n  z-index: 10; /* 다른 요소보다 위에 표시 */\n}\n\n/* 시간 구분자 스타일 */\n.time-separator {\n  margin: 0 15px;\n}\n\n/* 스크롤 스타일 커스터마이징 - 메인 컨테이너에만 적용 */\n.contract-settings-container::-webkit-scrollbar {\n  width: 6px;\n}\n\n.contract-settings-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n\n.contract-settings-container::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 10px;\n}\n\n.contract-settings-container::-webkit-scrollbar-thumb:hover {\n  background: #aaa;\n}\n\n/* 활성화/비활성화 상태에 따른 컨테이너 배경색 */\n.time-input-container.active {\n  background-color: #fff8f2; /* 활성화 상태: 메인 컬러(베이지) */\n}\n\n.time-input-container.inactive {\n  background-color: #e0e0e0; /* 비활성화 상태: 회색 */\n}\n\n/* 정규 출퇴근 시간 컨테이너 - 활성화 상태일 때만 회색 유지 */\n.regular-work-time.active {\n  background-color: #fff8f2; /* 정규 출퇴근 시간은 항상 회색 배경 */\n}\n\n/* 기본 임금 컨테이너 - 활성화/비활성화 상태 구분 */\n.wage-input-container.active {\n  background-color: #fff8f2; /* 활성화 상태: 메인 컬러(베이지) */\n}\n\n.wage-input-container.inactive {\n  background-color: #e0e0e0; /* 비활성화 상태: 회색 */\n}\n\n/* 도움말 박스 위치 수정 */\n.help-tip-box {\n  position: absolute;\n  bottom: 30px; /* 아래에서부터의 거리 */\n  left: 50%;    /* 가운데 정렬을 위해 */\n  transform: translateX(-50%); /* 가운데 정렬 완료 */\n  width: 300px;\n  background: white;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.2);\n  padding: 15px;\n  z-index: 100;\n}\n\n/* 도움말 박스 제목 */\n.help-tip-box h3 {\n  margin: 0 0 10px 0;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n/* 도움말 박스 내용 */\n.help-tip-box p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n/* 화살표 위치 수정 */\n.help-tip-arrow {\n  position: absolute;\n  width: 15px;\n  height: 15px;\n  background: white;\n  transform: rotate(45deg);\n  bottom: -8px;\n  left: 50%;    /* 가운데 정렬 */\n  margin-left: -7px; /* 화살표 크기의 절반만큼 다시 왼쪽으로 이동 */\n  border-right: 1px solid #ddd;\n  border-bottom: 1px solid #ddd;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
